/* eslint-disable */
import {
	useState,
	useEffect,
	useReducer,
	useCallback,
	useMemo,
	useRef,
} from 'react';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@/Components/ui/button';
import moment from 'moment';
import { useAuth } from '@/Components/Auth/Login/auth';
import {
	disableProductionPlanBtn,
	getProductMapping,
	getUnitConvertedUnit,
	useProductData,
} from '@/Helpers';
import { notificationServices } from '@/Services';
import { CheckPicker, SelectPicker } from 'rsuite';
import { ClipboardPaste, Edit, X } from 'lucide-react';
import { BackdropLoader } from '@/Components/Loaders';
import { AlertModalSecondary } from '../AlertModalSecondary';
import CreateClosingPage from '@/Pages/ProcessClosing/CreateClosingPage/CreateClosingPage';

const LeftOverModal = (props) => {
	const loadingRef = useRef(false);
	const { appConfig = {} } = useAuth();
	const { configs = {} } = appConfig || {};
	const { internalPOTypes = [] } = configs || {};
	const { show, data } = useSelector(
		(state) => state?.modal?.leftOverCreateModal
	);
	const dispatch = useDispatch();
	const handleClose = () => {
		dispatch(modalActions.toggleLeftOverCreateModal(false));
	};
	const [parentCallBackHolder, setParentCallBackHolder] = useState({confirmCallback:null, handleSuccess:(response)=>{
		props?.handleRefresh?.();
		handleClose();

	}, handleError:(errorObj)=>{}});
	
	// leftOverCreateModal(modalActions?.toggleProductionPlanModal(true, {
	// 	idsList,
	// 	storeId: state?.fromStore?.id,
	// 	date: moment(state?.expectedDeliveryDate).format('YYYY-MM-DD'),
	// 	listData: response?.data,
	// }));

	const renderBtns = () => {
		return (
			<div className='w-full flex flex-col gap-2'>
				<div className='w-full flex justify-center gap-2'>
					<Button
						className='flex-1 primary-btn !bg-slate-500'
						variant='secondary'
						onClick={()=>{
							handleClose();
						}}
					>
						Cancel
					</Button>
					<Button
						className='flex-1 primary-btn  border !border-amber-500'
						onClick={()=>{
							parentCallBackHolder?.confirmCallback?.();
						}}
					>
						Create Left Over
					</Button>
				</div>
			</div>
		);
	};

	return (
		<>
			<BaseModal
				heading={`Add left over inventory for ${data?.processName}, ( ${moment(data?.invDayEndOf).format('DD-MM-YYYY')})`}
				open={show}
				handleClose={handleClose}
				renderBtns={renderBtns}
				width='90%'
				height='90%'
				disableBackdropClick
				disableEscapeKeyDown
			>
			{/* <AlertModalSecondary/> */}
			<CreateClosingPage isTypeModal={true}  parentCallBackHolder={parentCallBackHolder} leftOverFixedData={data} />
			</BaseModal>
		</>
	);
};

export default LeftOverModal;
